import React, { createContext, useState, useEffect } from 'react';

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [client, setClient] = useState(null);
    const [gerant, setGerant] = useState(null);
    const [loading, setLoading] = useState(true); // Ajouter un état de chargement

    // Vérifier si les données ont expiré
    const hasExpired = (expiry) => {
        const now = Date.now();
        return now > expiry;
    };
  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    const storedClient = localStorage.getItem('client');
    const storedGerant = localStorage.getItem('gerant');
   

    if (storedUser) {
        const parsedUser = JSON.parse(storedUser);

        if (!hasExpired(parsedUser.expiry)) {
            setUser(parsedUser); // Charger toutes les données (y compris le rôle, email, etc.)
 
        } else {
            console.log("Données expirées");
            localStorage.removeItem('user');
        }
    } 

    if (storedGerant) {
        const parsedGerant = JSON.parse(storedGerant);

        if (!hasExpired(parsedGerant.expiry)) {
            setGerant(parsedGerant); // Charger toutes les données (y compris le rôle, email, etc.)
            console.log("Utilisateur non expiré, chargé :", parsedGerant);
        } else {
            console.log("Données expirées");
            localStorage.removeItem('gerant');
        }
    }

    if (storedClient) {
        const parsedClient = JSON.parse(storedClient);

        if (!hasExpired(parsedClient.expiry)) {
            setClient(parsedClient); // Charger toutes les données (y compris le rôle, email, etc.)
         
        } else {
            console.log("Données expirées");
            localStorage.removeItem('Client');
        }
    } else {
        console.log("Aucun utilisateur dans localStorage");
    }
 
    setLoading(false);
}, []);



    // Déconnexion et suppression des données
    const logout = () => {
        localStorage.removeItem('user');
        localStorage.removeItem('client');
        localStorage.removeItem('gerant');
        sessionStorage.clear(); // Supprimer les données de sessionStorage également
        setUser(null);
        setClient(null);
        setGerant(null);
        console.log('Logged out and cleared localStorage and sessionStorage');
    };

    return (
        <UserContext.Provider value={{ user, setUser, client, setClient, gerant, setGerant, logout, loading }}>
            {children}
        </UserContext.Provider>
    );
};
